import { useQuery } from '@apollo/client';

import { env } from '@/constant/env';
import {
  HAS_WORKSPACES_QUERY,
  type HasWorkspacesResult
} from '@/gql/queries/workflow-cards.gql';

// Whether the current user has access to any workspace. Used to gate the
// read-only "Production" header badge so users who never deal with workspaces
// don't see it. `enabled` lets callers skip the query on irrelevant routes.
export const useHasWorkspaces = (enabled = true) => {
  const on = env.FEATURE_FLAGS.USE_WORKFLOW_CARDS && enabled;
  const { data } = useQuery<HasWorkspacesResult>(HAS_WORKSPACES_QUERY, {
    skip: !on,
    fetchPolicy: 'cache-first'
  });
  return (data?.workspaces?.totalCount ?? 0) > 0;
};
